import $ from 'jquery';

export const navigation = () => {
    const $menuToggler = $('.burger');
    const $navigation = $('.navigation');
    const $header = $('header');

    $menuToggler.on('click', () => {
        $menuToggler.toggleClass('active');
        $header.toggleClass('active');
        $navigation.children().toggleClass('hidden');
    });
    var social_block = $('.social-block').detach();
    $('.navigation ul.nav').append(social_block);

};
